import { Component, OnInit, Input, Output, EventEmitter, TemplateRef } from '@angular/core';
import { GVechileViewModel } from 'src/app/viewmodels/g-vehicle/GVechileViewModel';
import { JqHelper } from 'src/app/common/jq-helper';
import { UnitOfWorkService } from 'src/app/services/api/uow/unit-of-work.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ItemViewModel, ItemViewModel1 } from 'src/app/viewmodels/ItemViewModel';
import Swal from 'sweetalert2';
import { NgxSpinnerService } from 'ngx-spinner';
import { SaveGVehicleRequest } from 'src/app/viewmodels/g-settings/GSettingViewModel';

@Component({
  selector: 'app-vehicle-form',
  templateUrl: './vehicle-form.component.html',
  styleUrls: ['./vehicle-form.component.scss']
})
export class VehicleFormComponent implements OnInit {
  @Input() public vm: SaveGVehicleRequest;
  @Input() public modal_title: any;
  @Input() public bsmRef: BsModalRef;
  @Output() onSubmitted = new EventEmitter<any>();
  private submitted = false;
  public IsDublicate: boolean = false;
  public IsRDublicate: boolean = false;
  public IsCDublicate: boolean = false;
  public IsEDublicate: boolean = false;
  public statusListItems: any = [];
  modalRefLv1: BsModalRef;
  modalRef: BsModalRef;

  public cbrands = 'brands';
  public brands: any = [];

  public cmodels = 'models';
  public models: any = [];
  public modelList: any = [];

  public cCustomers = 'customers';
  public customers: any[] = [];

  constructor(
    private _jq: JqHelper,
    private _uow: UnitOfWorkService,
    private _modalService: BsModalService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit() {
    debugger
    this.loadVehicleFormAsync();
    this.getVehicleStatusName();
    if (this.vm == undefined) {
      this.vm = new SaveGVehicleRequest();
    }
    else {
      this.vm.purchaseDate = this.formatDateForInput(this.vm.purchaseDate);
    }

    if (this.modal_title == undefined) {
      this.modal_title = 'Vehicle';
    }
    this._uow.logger.log(this.vm);
  }

  loadVehicleFormAsync() {
    debugger;
    this._uow.gSettingService.LoadVehicleFormAsync().subscribe(
      (res: any) => {
        debugger;
        this.customers = res.customers;
        this.brands = res.brands;
        this.modelList = res.models;

        if (this.vm != undefined) {
          this.brandChanged(this.vm.brand);
        }

        // this.itemVm.RegistraionNumber = res;
        console.log(res);
        this._jq.showSpinner();
        // this.itemVm.RegistraionNumber = res.code;
      },
      (error) => {
        this._uow.logger.log(error);
        this._jq.showSpinner();
      }
    );
  }

  getVehicleStatusName() {
    debugger;
    this._uow.gSettingService.GetVehicleStatusesAsync().subscribe(
      (res: any) => {
        debugger;
        this.statusListItems = res.result.map(x => {
          return {
            id: x.id, // or the actual ID field
            name: x.name // concatenated name and code
          };
        });

        // this.itemVm.RegistraionNumber = res;
        console.log(res);
        this._jq.showSpinner();
        // this.itemVm.RegistraionNumber = res.code;
      },
      (error) => {
        this._uow.logger.log(error);
        this._jq.showSpinner();
      }
    );
  }

  openModal(template: TemplateRef<any>, lvl: number = 1) {
    if (lvl == 1) {
      this.modalRefLv1 = this._uow.modalServiceEx.show(template);
    }
  }

  brandChanged(e: any) {
    debugger
    this.models = [];
    this.models = this.modelList.filter(x => x.brandId == e.id);
  }


  saveOrUpdate() {
    debugger
    // this._jq.showSpinner(true);
    this.vm.status = new ItemViewModel1();
    let status = this.statusListItems.find(
      x => x.name.toLowerCase() === "approved"
    );
    this.vm.purchaseDate = new Date(this.vm.purchaseDate);
    this.vm.status.id = status.id;
    this.spinner.show();
    this._uow.gSettingService
      .SaveGVehicleAsync(this.vm)
      .toPromise().then((res: any) => {
        console.log(res);
        this.submitted = true;
        this.bsmRef.hide();
        this.onSubmitted.emit(this.submitted);
        this.spinner.hide();
        Swal.fire(
          'Created!',
          'Created/Updated! Successfully',
          'success'
        )
      })
      .catch((error) => {
        Swal.fire(
          'Failure!',
          error.error.message,
          'error'
        )
        console.log(`Promise rejected with ${JSON.stringify(error)}`);
        this.onSubmitted.emit(this.submitted);
        console.log(error);
        this.spinner.hide();
      });
  }

  checkTagDublication(tagName, filter) {
    this._jq.showSpinner(true);
    this._uow.vehicleService.checkVehicleDublications(tagName, filter).toPromise().then((res: any) => {
      if (res === true) {
        this.IsDublicate = false;
        if (filter == 1) {
          this.IsRDublicate = false
        }
        if (filter == 2) {
          this.IsCDublicate = false
        }
        if (filter == 3) {
          this.IsEDublicate = false
        }
      } else {
        this.IsDublicate = true;
        if (filter == 1) {
          this.IsRDublicate = true
        }
        if (filter == 2) {
          this.IsCDublicate = true
        }
        if (filter == 3) {
          this.IsEDublicate = true
        }
      }
      this._jq.showSpinner(false);
    }).catch((error) => {
      console.log(`Promise rejected with ${JSON.stringify(error)}`);
      this.onSubmitted.emit(this.submitted);
      this._jq.showSpinner(false);
    });
  }


  compareFn(optionOne, optionTwo): boolean {
    if (optionOne !== undefined && optionTwo !== undefined) {
      return optionOne.id === optionTwo.id;
    }
  }
  // random unwanted fucks
  public toggleState = false;
  toggleVisbility() {
    this.toggleState = !this.toggleState;
  }
  // extrnal components
  onItemSubmitted(e, mf) {
    console.log(e);
    if (e === true) {
      this.loadVehicleFormAsync();
      // if (mf == this.cbrands) {
      //   this.getBrands();
      // }
      // if (mf == this.cmodels) {
      //   this.getModels();
      // }
      // if (mf == this.cCustomers) {
      //   this.getCustomers();
      // }
    }
  }

  formatDateForInput(date: any): string {
    if (!date) return '';
    const d = new Date(date);
    const year = d.getFullYear();
    const month = ('0' + (d.getMonth() + 1)).slice(-2);
    const day = ('0' + d.getDate()).slice(-2);
    return `${year}-${month}-${day}`;
  }

  closeModal() {
    this.bsmRef.hide();
    this.onSubmitted.emit(true); // Emit event to refresh list
  }
}
